// extracted by mini-css-extract-plugin
export default {"listItem":"PrivacyPolicy_listItem__sBrf8","headingStyle":"PrivacyPolicy_headingStyle__rzh47"};